// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
    transition: ease-in-out 0.3s;
    position: relative;
    height: 100vh;
    display: flex;
    align-items: center;
    z-index: 997;
    overflow-y: auto;
  }
  
  #header * {
    transition: ease-in-out 0.3s;
  }
  
  #header h1 {
    font-size: 48px;
    color: white;
    margin: 0;
    padding: 0;
    line-height: 1;
    font-weight: 700;
    font-family: "Poppins", sans-serif;
  }
  
  #header h2 {
    font-size: 24px;
    margin-top: 20px;
    color: rgba(255, 255, 255, 0.8);
  }
  
  #header h2 span {
    color: #fff;
    border-bottom: 2px solid rgb(241, 137, 241);
    padding-bottom: 6px;
  }

  #header .social-links {
    margin-top: 20px;
    display: flex;
  }
  
  #header .social-links a {
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    line-height: 1;
    margin-right: 8px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
  
  #header .social-links a:hover {
    background: rgb(241, 137, 241);
  }
  
  @media (max-width: 992px) {
    #header h1 {
      font-size: 36px;
    }
  
    #header h2 {
      font-size: 20px;
      line-height: 30px;
    }
  
    #header .social-links {
      margin-top: 15px;
    }
  
    #header .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 999;
    }
  }

  h4 {
    color: white;
    font-size: 20px;
  }
  
  /* Header Top */

  #header.header-top {
    height: 80px;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
  }
  
  #header.header-top .social-links,
  #header.header-top h2 {
    display: none;
  }
  
  #header.header-top h1 {
    margin-right: auto;
    font-size: 36px;
  }
  
  #header.header-top img {
    max-height: 60px;
    margin-right: 20px !important;
  }
  
  #header.header-top .container {
    display: flex;
    align-items: center;
  }
  
  #header.header-top .navbar {
    margin: 0;
  }
  
  @media (max-width: 768px) {
    #header.header-top {
      height: 60px;
    }
  
    #header.header-top h1 {
      font-size: 26px;
    }
  }

.my-3 {
  color: white;
  padding-top: 20px;
  font-size: 15px;
}

.overlay {
    position: fixed; /* Fixed position to cover the whole screen */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.96); 
    z-index: 998; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}
.overlay-content {
    margin: 15px; 
    padding: 20px; 
    background: white; 
    border-radius: 5px; 
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2); 
    overflow-y: auto; 
    max-height: 90vh;
}
@media (max-width: 768px) {
  .overlay {
      position: absolute; 
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,2CAA2C;IAC3C,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,YAAY;IACd;EACF;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,eAAe;;EAEf;IACE,YAAY;IACZ,eAAe;IACf,OAAO;IACP,MAAM;IACN,QAAQ;IACR,8BAA8B;EAChC;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF;;AAEF;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;IACI,eAAe,EAAE,6CAA6C;IAC9D,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;AAC3C;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;AACA;EACE;MACI,kBAAkB;EACtB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');\n#header {\n    transition: ease-in-out 0.3s;\n    position: relative;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    z-index: 997;\n    overflow-y: auto;\n  }\n  \n  #header * {\n    transition: ease-in-out 0.3s;\n  }\n  \n  #header h1 {\n    font-size: 48px;\n    color: white;\n    margin: 0;\n    padding: 0;\n    line-height: 1;\n    font-weight: 700;\n    font-family: \"Poppins\", sans-serif;\n  }\n  \n  #header h2 {\n    font-size: 24px;\n    margin-top: 20px;\n    color: rgba(255, 255, 255, 0.8);\n  }\n  \n  #header h2 span {\n    color: #fff;\n    border-bottom: 2px solid rgb(241, 137, 241);\n    padding-bottom: 6px;\n  }\n\n  #header .social-links {\n    margin-top: 20px;\n    display: flex;\n  }\n  \n  #header .social-links a {\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.1);\n    color: #fff;\n    line-height: 1;\n    margin-right: 8px;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n  }\n  \n  #header .social-links a:hover {\n    background: rgb(241, 137, 241);\n  }\n  \n  @media (max-width: 992px) {\n    #header h1 {\n      font-size: 36px;\n    }\n  \n    #header h2 {\n      font-size: 20px;\n      line-height: 30px;\n    }\n  \n    #header .social-links {\n      margin-top: 15px;\n    }\n  \n    #header .container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      z-index: 999;\n    }\n  }\n\n  h4 {\n    color: white;\n    font-size: 20px;\n  }\n  \n  /* Header Top */\n\n  #header.header-top {\n    height: 80px;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.9);\n  }\n  \n  #header.header-top .social-links,\n  #header.header-top h2 {\n    display: none;\n  }\n  \n  #header.header-top h1 {\n    margin-right: auto;\n    font-size: 36px;\n  }\n  \n  #header.header-top img {\n    max-height: 60px;\n    margin-right: 20px !important;\n  }\n  \n  #header.header-top .container {\n    display: flex;\n    align-items: center;\n  }\n  \n  #header.header-top .navbar {\n    margin: 0;\n  }\n  \n  @media (max-width: 768px) {\n    #header.header-top {\n      height: 60px;\n    }\n  \n    #header.header-top h1 {\n      font-size: 26px;\n    }\n  }\n\n.my-3 {\n  color: white;\n  padding-top: 20px;\n  font-size: 15px;\n}\n\n.overlay {\n    position: fixed; /* Fixed position to cover the whole screen */\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.96); \n    z-index: 998; \n    display: flex; \n    justify-content: center; \n    align-items: center; \n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n}\n.overlay-content {\n    margin: 15px; \n    padding: 20px; \n    background: white; \n    border-radius: 5px; \n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2); \n    overflow-y: auto; \n    max-height: 90vh;\n}\n@media (max-width: 768px) {\n  .overlay {\n      position: absolute; \n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
